export default __webpack_public_path__ + "static/tooltip-truncation-dont-light-6ed0bc2bad2d76ee1e6a0f6b16f4c613.png";